const baseUrl = 'https://houseoss.4dkankan.com/chenfang/assets';

let data = [
  {
    image: baseUrl + "/images/thumb/cflz.jpg",
    link:'cflz',
    audio:'17陈芳老宅cp',
    tag:'cflz',
    type:'panorama',
    text: "陈芳老宅"
  },
  {
    image: baseUrl + "/images/thumb/ehdl.jpg",
    link:'cfgj',
    audio:'9二号碉楼cp',
    tag:'ehdl',
    type:'panorama',
    text: "二号碉楼"
  },
  {
    image: baseUrl + "/images/thumb/cldz.jpg",
    link:'cldz',
    audio:'16陈龙大宅cp',
    tag:'cldz',
    type:'panorama',
    text: "陈龙大宅"
  },
  {
    image: baseUrl + "/images/thumb/dhef.jpg",
    link:'dhef',
    audio:'14雕花耳房cp',
    tag:'dhef',
    type:'panorama',
    text: "雕花耳房"
  },
  {
    image: baseUrl + "/images/thumb/jdl.jpg",
    link:'jdl',
    audio:'10家丁楼cp',
    tag:'jdl',
    type:'panorama',
    text: "家丁楼"
  },
  {
    image: baseUrl + "/images/thumb/yqrk.jpg",
    link:'mxxy',
    audio:'1园区入口cp',
    tag:'yqrk',
    type:'panorama',
    text: "园区入口"
  },
  {
    image: baseUrl + "/images/thumb/mxpf.jpg",
    link:'pfq1',
    audio:'2梅溪牌坊cp',
    tag:'mxpf',
    type:'panorama',
    text: "梅溪牌坊"
  },
  // {
  //   image: baseUrl + "/images/thumb/23.jpg",
  //   link:'sbl',
  //   tag:'sbl',
  //   type:'panorama',
  //   text: "石板路"
  // },
  {
    image: baseUrl + "/images/thumb/shdl.jpg",
    link:'shdl',
    audio:'18三号碉楼cp',
    tag:'shdl',
    type:'panorama',
    text: "三号碉楼"
  },
  {
    image: baseUrl + "/images/thumb/xpf.jpg",
    link:'xpf',
    audio:'3小牌坊cp',
    tag:'xpf',
    type:'panorama',
    text: "小牌坊"
  },
  {
    image: baseUrl + "/images/thumb/xy.jpg",
    link:'xy',
    audio:'5乡约cp',
    tag:'xy',
    type:'panorama',
    text: "乡约"
  },
  {
    image: baseUrl + "/images/thumb/yhdl.jpg",
    link:'yhdl',
    audio:'4一号碉楼cp',
    tag:'yhdl',
    type:'panorama',
    text: "一号碉楼"
  },
  {
    image: baseUrl + "/images/thumb/zwcgc.jpg",
    link:'777',
    audio:'13占五陈公祠cp',
    tag:'zwcgc',
    type:'bigscene',
    text: "占五陈公祠"
  },
  {
    image: baseUrl + "/images/thumb/mxdm.jpg",
    link:'778',
    audio:'6梅溪大庙cp',
    tag:'mxdm',
    type:'bigscene',
    text: "梅溪大庙"
  },
  {
    image: baseUrl + "/images/thumb/cjgt.jpg",
    link:'779',
    audio:'12陈家戏台cp',
    tag:'cjgt',
    type:'bigscene',
    text: "陈家戏台"
  },
  {
    image: baseUrl + "/images/thumb/cgydz.jpg",
    link:'780',
    audio:'15陈庚虞大宅cp',
    tag:'cgydz',
    type:'bigscene',
    text: "陈庚虞大宅"
  },
  {
    image: baseUrl + "/images/thumb/ht.jpg",
    link:'bZ8Ahwxa',
    audio:'8花厅cp',
    tag:'ht',
    type:'4dkankan',
    text: "花厅"
  },
  {
    image: baseUrl + "/images/thumb/csdzc.jpg",
    link:'625',
    audio:'7陈氏大宗祠cp',
    tag:'csdzc',
    type:'bigscene',
    text: "陈氏大宗祠"
  },
  {
    image: baseUrl + "/images/thumb/cxydz.jpg",
    link:'626',
    audio:'11陈席儒大宅cp',
    tag:'cxydz',
    type:'bigscene',
    text: "陈席儒大宅"
  }
]


export { data };
